module.exports = __webpack_public_path__ + "img/auth_logo.9bf94074.png";